import React from 'react'
import '../css/progress.sass'
import {CheckOutlined} from '@ant-design/icons';
import {
    MATERIAL_FILL_STEP,
    SELECTED_ORGANIZATION,
    SIGNED,
    SUBMIT_MATERIAL,
    WAIT_SIGN
} from "../wechatSubMchApplicationStep";

const Progress = (props) => {
    let {step} = props;
    return (
        <ul className='progress flex'>
            <li className={step >= SELECTED_ORGANIZATION ? ' afterLine active' : ' afterLine'}>
                <p className='circular'>
                    {
                        step < SELECTED_ORGANIZATION ? 1 : (
                            <CheckOutlined/>
                        )
                    }
                </p>
                <p className=''>选择入驻主体类型</p>
            </li>
            <li className={step >= MATERIAL_FILL_STEP ? ' afterLine  active' : '  afterLine'}>
                <p className='circular'>
                    {
                        step < MATERIAL_FILL_STEP ? 2 : (
                            <CheckOutlined/>
                        )
                    }
                </p>
                <p className=''>填写资料</p>
            </li>
            <li className={step >= SUBMIT_MATERIAL ? ' afterLine active' : ' afterLine'}>
                <p className='circular'>
                    {
                        step < SUBMIT_MATERIAL ? 3 : (
                            <CheckOutlined/>
                        )
                    }
                </p>
                <p>微信审核</p>
            </li>
            <li className={step >= WAIT_SIGN ? ' afterLine active' : ' afterLine'}>
                <p className='circular'>
                    {
                        step < WAIT_SIGN ? 4 : (
                            <CheckOutlined/>
                        )
                    }
                </p>
                <p>商户签约</p>
            </li>
            <li className={step >= SIGNED ? 'active' : ''}>
                <p className='circular'>
                    {
                        step < SIGNED ? 5 : (
                            <CheckOutlined/>
                        )
                    }
                </p>
                <p>进件完成</p>
            </li>
        </ul>
    );
}
export default Progress;